// extracted by mini-css-extract-plugin
export var textBlock = "PrivacyCenter-module--textBlock--DSc8F";
export var wrapper = "PrivacyCenter-module--wrapper--+5wf2";